import {authHeader, handleResponsePublic as handleResponse} from '../_helpers';

export const promptService = {
  register,
  getAll,
  getPlainList,
  getById,
  update,
  delete: _delete,
};

async function getAll(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/prompts${api_params}`, requestOptions).then(handleResponse);
}

async function getPlainList(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/prompts/plain/list${api_params}`, requestOptions).then(handleResponse);
}

async function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/prompts/${id}`, requestOptions).then(handleResponse);
}

async function register(prompt) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(prompt)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/prompts`, requestOptions).then(handleResponse);
}

async function update(prompt) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(prompt)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/prompts/${prompt.id}`, requestOptions).then(handleResponse);
}

// prefixed async function name with underscore because delete is a reserved word in javascript
async function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    cache: 'no-store',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}/prompts/${id}`, requestOptions).then(handleResponse);
}